export enum StagingGridColumnId {
  // Order fields
  ORDER_AXE_ID = 'ORDER_AXE_ID',
  ORDER_DIRECTION = 'ORDER_DIRECTION',
  ORDER_FUND_ID = 'ORDER_FUND_ID',
  ORDER_NOTIONAL = 'ORDER_NOTIONAL',
  ORDER_RATE = 'ORDER_RATE',
  ORDER_PREV_RATE = 'ORDER_PREV_RATE',
  ORDER_FEE = 'ORDER_FEE',
  ORDER_REFERENCE_RATE = 'ORDER_REFERENCE_RATE',
  ORDER_START_DATE = 'ORDER_START_DATE',
  ORDER_END_DATE = 'ORDER_END_DATE',
  ORDER_STATUS = 'ORDER_STATUS',
  ORDER_TERM = 'ORDER_TERM',
  ORDER_BOOK = 'ORDER_BOOK',
  ORDER_NOTE = 'ORDER_NOTE',
  ORDER_STRATEGY = 'ORDER_STRATEGY',
  ORDER_PRIME_BROKER = 'ORDER_PRIME_BROKER',
  ORDER_BUNDLE = 'ORDER_BUNDLE',
  ORDER_REPO_TYPE = 'ORDER_REPO_TYPE',
  ORDER_TRADE_TYPE = 'ORDER_TRADE_TYPE',
  ORDER_BOND_PRICE = 'ORDER_BOND_PRICE',
  ORDER_ACCRUED_INTEREST = 'ORDER_ACCRUED_INTEREST',
  ORDER_START_CONSIDERATION = 'ORDER_START_CONSIDERATION',
  ORDER_ABSOLUTE_CONSIDERATION = 'ORDER_ABSOLUTE_CONSIDERATION',
  ORDER_MARKET = 'ORDER_MARKET',
  ORDER_EXTERNAL_ID = 'ORDER_EXTERNAL_ID',
  ORDER_ID = 'ORDER_ID',
  ORDER_UPDATED_BY = 'ORDER_UPDATED_BY',
  ORDER_CREATED_AT_DATE = 'ORDER_CREATED_AT_DATE',
  ORDER_CREATED_AT_TIME = 'ORDER_CREATED_AT_TIME',
  ORDER_CREATED_BY = 'ORDER_CREATED_BY',
  COUNTERPARTY_NAME = 'COUNTERPARTY_NAME',
  AXE_ROLL_UNWIND = 'AXE_ROLL_UNWIND',
  INVESTMENT_DECISION_MAKER = 'INVESTMENT_DECISION_MAKER',
  EXECUTION_DECISION_MAKER = 'EXECUTION_DECISION_MAKER',
  CALLABLE = 'CALLABLE',
  CALLABLE_PERIOD_DAYS = 'CALLABLE_PERIOD_DAYS',
  NOTICE_PERIOD_DAYS = 'NOTICE_PERIOD_DAYS',
  BLOCK_TRADE = 'BLOCK_TRADE',
  ALLOW_PARTIAL = 'ALLOW_PARTIAL',
  ORDER_TARGET_FILL_NOTIONAL = 'ORDER_TARGET_FILL_NOTIONAL',
  ORDER_TARGET_FILL_START_CONSIDERATION = 'ORDER_TARGET_FILL_START_CONSIDERATION',
  RFQ_TYPE = 'RFQ_TYPE',
  PRE_AGREED = 'PRE_AGREED',
  MASTER_LEGAL_AGREEMENT_TYPE = 'MASTER_LEGAL_AGREEMENT_TYPE',
  START_CONSIDERATION_OVERRIDE = 'START_CONSIDERATION_OVERRIDE',
  SETTLEMENT = 'SETTLEMENT',
  CSD = 'CSD',
  CLEARING_VENUE = 'CLEARING_VENUE',
  SPONSORING_BANK = 'SPONSORING_BANK',
  LINKED_TRADE_ID = 'LINKED_TRADE_ID',
  MY_ENTITY_SHORT_NAME = 'MY_ENTITY_SHORT_NAME',
  MY_FICC_ENTITY_SHORT_NAME = 'MY_FICC_ENTITY_SHORT_NAME',
  FACTOR = 'FACTOR',
  ASSET_TYPE = 'ASSET_TYPE',
  EVERGREEN_NOTICE_PERIOD = 'EVERGREEN_NOTICE_PERIOD',
  ISSUE = 'ISSUE',
  MARKET_TRADE_DATE = 'MARKET_TRADE_DATE',
  ROE = 'ROE',
  ROS = 'ROS',
  HAIRCUT = 'HAIRCUT',
  HAIRCUT_TYPE = 'HAIRCUT_TYPE',

  // Detail columns
  BOOK_NAME = 'BOOK_NAME',
  COLLATERAL_NAME = 'COLLATERAL_NAME',
  SECONDARY_COLLATERAL_NAME = 'SECONDARY_COLLATERAL_NAME',
  STOCK_BORROW_LENDING_TYPE = 'STOCK_BORROW_LENDING_TYPE',
  COLLATERAL_CURRENCY = 'COLLATERAL_CURRENCY',
  COLLATERAL_ISIN_OR_BUI = 'COLLATERAL_ISIN_OR_BUI',
  COLLATERAL_CUSIP = 'COLLATERAL_CUSIP',
  COLLATERAL_COUPON = 'COLLATERAL_COUPON',
  COLLATERAL_ISSUER = 'COLLATERAL_ISSUER',
  FUND_LEI = 'FUND_LEI',
  FUND_NAME = 'FUND_NAME',
  PRODUCT = 'PRODUCT',
  PRODUCT_SECTOR = 'PRODUCT_SECTOR',
  REFERENCE_RATE_NAME = 'REFERENCE_RATE_NAME',
  FLOAT_CRYSTALLISATION_DAYS = 'FLOAT_CRYSTALLISATION_DAYS',
  REPO_TYPE_NAME = 'REPO_TYPE_NAME',
  STRATEGY_NAME = 'STRATEGY_NAME',
  UPLOAD_ROW_INDEX = 'UPLOAD_ROW_INDEX'
}

export const OrderFieldNames = {
  DIRECTION: 'order.direction',
  FUND_ID: 'order.fundId',
  ISIN: 'order.collateralId',
  EVERGREEN_NOTICE_PERIOD: 'order.evergreenNoticePeriod',
  BASKET_ID: 'order.basketAllocation.basketId',
  NOTIONAL: 'order.notional',
  RATE: 'order.rate',
  FEE: 'order.fee',
  REFERENCE_RATE: 'order.referenceRate',
  START_DATE: 'order.startDate',
  END_DATE: 'order.endDate',
  STATUS: 'order.status',
  TERM: 'order.term',
  CURRENCY: 'order.currency',
  BOOK: 'order.book',
  STRATEGY: 'order.strategy',
  PRIME_BROKER: 'order.primeBrokerId',
  BUNDLE: 'order.bundle',
  REPO_TYPE: 'order.repoType',
  BOND_PRICE: 'order.bondPrice',
  REPO_CLASSIFICATION: 'order.repoClassification',
  ACCRUED_INTEREST: 'order.accruedInterest',
  START_CONSIDERATION: 'order.startConsideration',
  START_CONSIDERATION_OVERRIDE: 'order.startConsiderationOverride',
  EXTERNAL_ID: 'order.externalOrderId',
  ALIAS: 'order.negotiationInstruction.counterpartyInstructions[0].counterpartyAlias',
  COUNTERPARTY_NAME: 'order.negotiationInstruction.counterpartyInstructions[0].counterpartyId',
  AXE: 'order.negotiationInstruction.counterpartyInstructions[0].isAxed',
  ROLL_UNWIND: 'order.negotiationInstruction.counterpartyInstructions[0].tradeConditionFlag',
  INVESTMENT_DECISION_MAKER: 'order.investmentDecisionMaker',
  EXECUTION_DECISION_MAKER: 'order.executionDecisionMaker',
  CALLABLE_TYPE: 'order.callableType',
  CALLABLE_PERIOD_DAYS: 'order.callablePeriodDays',
  NOTICE_PERIOD_DAYS: 'order.noticePeriodDays',
  BLOCK_TRADE: 'order.blockTrade',
  RFQ_TYPE: 'order.rfqType',
  CREATED_BY: 'order.createdBy',
  CREATED_AT: 'order.createdAt',
  UPDATED_BY: 'order.lastUpdatedBy',
  UPDATED_AT: 'order.lastUpdatedAt',
  NOTES: 'order.notes',
  ALLOW_PARTIAL: 'order.allowPartial',
  TARGET_FILL_NOTIONAL: 'order.targetFillNotional',
  TARGET_FILL_START_CONSIDERATION: 'order.targetFillStartConsideration',
  PRE_AGREED: 'order.preAgreed',
  MASTER_LEGAL_AGREEMENT_TYPE: 'order.masterLegalAgreementType',
  COLLATERAL_ID: 'order.collateralId',
  SECONDARY_COLLATERAL_ID: 'order.secondaryCollateralId',
  SECONDARY_BASKET_ID: 'order.secondaryBasketId',
  STOCK_BORROW_LENDING_TYPE: 'order.stockBorrowingLendingType',
  COUNTERPARTY: 'counterparty',
  ROE: 'order.rightOfExit',
  ROS: 'order.rightOfSubstitution',
  HAIRCUT_TYPE: 'order.haircutType',
  HAIRCUT: 'order.haircut'
}
